<template>
  <div class="box columns">
    <div class="column is-3">
      <div class="card" name="header">
        <div class="card-content">
          <h1 class="title is-3">- Edirne Tava Ciğer -</h1>
          <div>
            <p class="is-size-5">Bugüne kadar Toplam:</p>
            <p class="is-size-5">
              <span class="has-text-info has-text-weight-semibold">{{
                formattedNumber(total, "Porsiyon")
              }}</span>
              Tava Ciğer ürettin
            </p>
          </div>
          <div class="buttons is-centered">
            <button
              class="button is-success"
              :disabled="materials > 0 ? false : true"
              @click="make"
            >
              Tava Ciğer Hazırla
            </button>
          </div>
        </div>
      </div>
      <article class="panel is-default has-text-weight-semibold">
        <p class="panel-heading">İşletme</p>
        <div v-if="total > 100" class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-lira-sign" aria-hidden="true"></i>
          </span>
          <p>
            Gelir:
            <span class="has-text-success">{{
              Math.round(incomeRate * 10) / 10
            }}</span>
            ₺/Saniye
          </p>
        </div>
        <div v-if="total > 100" class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-tachometer-alt" aria-hidden="true"></i>
          </span>
          <p>
            Satış Hızı:
            <span class="has-text-success">{{
              Math.round(sellingRate * 10) / 10
            }}</span>
            Porsiyon/Saniye
          </p>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-money-bill" aria-hidden="true"></i>
          </span>
          <p>
            Nakit:
            <span class="has-text-info">{{ formattedNumber(cash, "₺") }}</span>
          </p>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-concierge-bell" aria-hidden="true"></i>
          </span>
          <p>
            Hazır Ciğer:
            <span
              class="has-text-info"
              :class="stocks == 0 ? 'has-text-danger' : false"
              >{{ formattedNumber(stocks, "Porsiyon") }}</span
            >
          </p>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-tag" aria-hidden="true"></i>
          </span>
          <div class="field has-addons">
            <p class="control">
              <span class="label field-label is-size-5">Fiyat:</span>
            </p>

            <p class="control">
              <input
                class="input has-text-info  has-text-weight-semibold"
                v-model="price"
                type="text"
              />
            </p>
            
            <p class="control">
              <a class="button is-static">₺</a>
            </p>

          </div>
        <div class="field">            <p class="control ">
              <a class="button is-success is-light" @click="increasePrice"
                >&uarr; Arttır</a
              >
            </p>
            <p class="control ">
              <a class="button is-danger is-light" @click="decreasePrice"
                >&darr; Azalt</a
              >
            </p></div>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-smile" aria-hidden="true"></i>
          </span>
          <p>
            Talep:
            <span class="has-text-info">{{ Math.round(demandRate) }} %</span>
          </p>
        </div>
      </article>
      <!-- Marketing Section -->
      <article class="panel is-default has-text-weight-semibold">
        <p class="panel-heading">Pazarlama</p>
        <div class="panel-block is-size-5">
          <span class="panel-icon is-size-5">
            <i class="fas fa-bank" aria-hidden="true"></i>
          </span>
          <p>
            Seviye:
            <span class="has-text-info">{{ markettingLvl }}</span>
          </p>
          <button
            class="button is-light"
            :disabled="cash >= markettingLvlUpCost ? false : true"
            :class="cash >= markettingLvlUpCost ? 'is-success' : false"
            @click="marketingLvlUp"
          >
            Yükselt ({{ formattedNumber(markettingLvlUpCost, "₺") }})
          </button>
        </div>
      </article>
      <!-- END Marketing Section -->
      <!-- Manufacturing Section -->
      <article class="panel is-default has-text-weight-semibold">
        <p class="panel-heading">Üretim</p>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-cogs" aria-hidden="true"></i>
          </span>
          <p>
            Üretim Hızı:
            <span
              :class="
                productionRate > 0 ? 'has-text-success' : 'has-text-danger'
              "
              >{{ Math.round(productionRate * 10) / 10 }}</span
            >
            Porsiyon/Saniye
          </p>
        </div>
        <div class="panel-block is-size-5" v-if="total > 1000">
          <span class="panel-icon">
            <i class="fas fa-robot" aria-hidden="true"></i>
          </span>

          <div class="field">
            <input
              id="switchExample"
              type="checkbox"
              name="switchExample"
              class="switch is-success"
              v-model="autoBuyMaterials"
            />
            <label for="switchExample">Otomatik Satın Al</label>
          </div>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon">
            <i class="fas fa-warehouse" aria-hidden="true"></i>
          </span>
          <p>
            Dana Ciğer:
            <span :class="materials == 0 ? 'has-text-danger' : false">{{
              Math.round(materials * 10) / 10
            }}</span>
            Kg
          </p>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon is-size-5">
            <i class="fas fa-shopping-basket" aria-hidden="true"></i>
          </span>
          <div class="field has-addons">
            <p class="control">
              <input
                class="input has-text-info has-text-weight-semibold"
                v-model="materialLot"
                type="text"
              />
            </p>
            <p class="control">
              <a class="button is-static">KG</a>
            </p>
            <p class="control">
              <a
                class="button is-light"
                :disabled="cash >= materialCost * materialLot ? false : true"
                :class="
                  cash >= materialCost * materialLot ? 'is-success' : false
                "
                @click="buyMaterials"
                >Satın Al - ({{
                  (materialCost * materialLot).toLocaleString()
                }}
                ₺)</a
              >
            </p>
          </div>
        </div>
        <div class="panel-block is-size-5">
          <span class="panel-icon is-size-5">
            <i class="fas fa-users" aria-hidden="true"></i>
          </span>
          <p class="control is-size-5">
            Personel:
            <span
              class="has-text-info"
              :class="workers == 0 ? 'has-text-danger' : false"
              >{{ workers }}</span
            >
          </p>
          <p class="control">
            <a
              class="button is-light"
              :disabled="cash >= workerCost ? false : true"
              :class="cash >= workerCost ? 'is-success' : false"
              @click="buyWorker"
              >Personel Al - ({{ workerCost.toLocaleString() }} ₺)</a
            >
          </p>
        </div>
      </article>
      <!-- END Manufacturing Section -->
    </div>
    <div class="column"></div>
    <div class="column"></div>
  </div>
</template>

<script>
export default {
  name: "GameMain",
  props: {},
  data: () => {
    return {
      totalEarned: 0,
      lastTotalEarned: 0,
      totalSold: 0,
      lasTotalSold: 0,
      total: 0,
      cash: 0,
      stocks: 0,
      lastTotal: 0,
      lastTotalTs: 0,
      price: 25,
      maxPrice: 120,
      minPrice: 1,
      materials: 20,
      materialCost: 40,
      materialUnitCost: 0.2,
      materialLot: 50,
      productionRate: 0,
      sellingRate: 0,
      incomeRate: 0,
      autoBuyMaterials: false,
      demandRate: 0,
      demandBoost: 0.05,
      currentDemand: 0,
      markettingLvl: 1,
      markettingLvlUpCost: 200,
      marketingEffectiveness: 1,
      prestigeU: 1,
      workers: 0,
      workerCost: 2100,
      workerBaseCost: 2100,
      sellInterval: 300,
      workersInterval: 1000,
      workersIntervalId: null
    };
  },
  methods: {
    increasePrice() {
      this.price++;
    },
    decreasePrice() {
      this.price--;
    },
    make() {
      if (this.materials > 0) {
        this.total++;
        this.stocks++;
        this.materials -= this.materialUnitCost;
        this.materials = Math.round(this.materials * 10) / 10;
      }
    },
    sell() {
      const demand = Math.floor(
        Math.random() *
          this.demandRate *
          this.demandBoost *
          this.marketingEffectiveness
      );
      // console.log("Hesaplanan Talep: " + demand);
      // console.log("Mevcut Talep: " + this.demandRate);
      if (demand < this.demandRate) {
        // console.log("Gerçekleşecek Talep: " + demand);
        this.currentDemand = demand;
        if (this.stocks < this.currentDemand) {
          this.cash += this.stocks * this.price;
          this.stocks = 0;
          this.totalSold += this.stocks;
          this.totalEarned += this.stocks * this.price;
        } else {
          this.cash += this.currentDemand * this.price;
          this.stocks -= this.currentDemand;
          this.totalSold += this.currentDemand;
          this.totalEarned += this.currentDemand * this.price;
        }
      }
    },
    buyWorker() {
      if (this.workerCost <= this.cash) {
        this.workers++;
        this.cash -= this.workerCost;
        this.workerCost = this.workerBaseCost * (this.workers + 1);
        this.addWorker();
      }
    },
    calcDemandRate() {
      let rate = Math.round(100 - (this.price / this.maxPrice) * 99);
      rate = Math.min(Math.max(0, rate), 100);
      this.demandRate = rate;
      // console.log("Talep Çarpanı: " + this.demandRate);
      return rate;
    },
    update: function() {
      setInterval(() => {
        if (Date.now() - this.lastTotalTs > 10000) {
          this.lastTotalTs = Date.now();
          this.productionRate = (this.total - this.lastTotal) / 10;
          this.sellingRate = (this.totalSold - this.lastTotalSold) / 10;
          this.incomeRate = (this.totalEarned - this.lastTotalEarned) / 10;
          this.lastTotal = this.total;
          this.lastTotalEarned = this.totalEarned;
          this.lastTotalSold = this.totalSold;
        }
        this.stocks > 0 ? this.sell() : false;
      }, this.sellInterval);
    },
    buyMaterials() {
      this.materials += this.materialLot;
      this.cash -= this.materialCost * this.materialLot;
    },
    marketingLvlUp() {
      if (this.markettingLvlUpCost <= this.cash) {
        this.cash -= this.markettingLvlUpCost;
        this.markettingLvl++;
        this.markettingLvlUpCost =
          (this.markettingLvlUpCost +
            (this.markettingLvlUpCost ^ (1.5 / this.markettingLvl + 1)) * 5) ^
          (this.markettingLvl + 1);
        this.marketingEffectiveness = this.markettingLvl ^ 0.4;
      }
    },
    addWorker() {
      clearInterval(this.workersIntervalId);
      this.workersIntervalId = setInterval(() => {
        for (let index = 0; index < this.workers; index++) {
          this.make();
        }
      }, this.workersInterval);
    }
  },
  computed: {
    formattedNumber: function() {
      return (val, unit) => val.toLocaleString() + " " + unit;
    }
  },
  watch: {
    price: function() {
      let demandRate = this.calcDemandRate();
      this.demandRate = demandRate;
      this.price = Math.min(Math.max(this.price, 1), 120);
      return this.price;
    },
    materials: function() {
      if (this.materials == 0 && this.autoBuyMaterials) {
        this.buyMaterials();
      }
    }
  },
  mounted: function() {
    this.demandRate = this.calcDemandRate();
    this.update();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
tr :nth-child(2) {
  padding-left: 1em;
}
.field.has-addons {
  margin-bottom: 0;
}
.card {
  margin-bottom: 1em;
}
</style>
